import type { HTMLAttributes, InputHTMLAttributes } from "react";
import { useLayoutEffect, useRef, useState } from "react";

import type { TextFieldUnionProps } from "@braintrust/braintrust-ui-components";

type UseJobLocationExpandableTextFieldProps = TextFieldUnionProps;

export const useJobLocationExpandableField = (
  props: UseJobLocationExpandableTextFieldProps,
) => {
  const spanRef = useRef<HTMLSpanElement>(null);
  const [textWidth, setTextWidth] = useState(0);

  // `slotProps.htmlInput`/`slotProps.input` are typed as a union that also
  // allows an ownerState callback form; in this codebase they're always
  // passed as plain objects, so narrow them for direct property access.
  const htmlInput = props.slotProps?.htmlInput as
    InputHTMLAttributes<HTMLInputElement> | undefined;
  const input = props.slotProps?.input as
    | (HTMLAttributes<HTMLDivElement> & { startAdornment?: React.ReactNode })
    | undefined;

  const setTextFieldWidth = (spaces: number) => {
    if (spanRef.current) {
      setTextWidth(
        spanRef.current.getBoundingClientRect().width + spaces * 4.22,
      );
    }
  };

  useLayoutEffect(() => {
    const numberOfSpaces = (String(htmlInput?.value ?? "").match(/ /g) || [])
      .length;

    setTextFieldWidth(numberOfSpaces);
  }, [input?.startAdornment, htmlInput?.value]);

  const getSpanText = () => {
    if (!String(htmlInput?.value ?? "").length && !input?.startAdornment) {
      return props.placeholder;
    }

    return htmlInput?.value;
  };

  return {
    spanRef,
    textWidth: textWidth,
    spanText: getSpanText(),
  };
};
